/**
 * Hook misji „Kopnij piłkę 3 razy" — tylko EMIT (W9-B / QuestLayer).
 * Dedup: ten sam kickId nie zwiększa postępu (sync tick / re-emit).
 */
export const INTERACT_BUS_EVENT = 'pieskowo:interact';
export const PARK_QUEST_ID = 'park_ball' as const;

export type ParkMissionPayload = {
  sceneKey: 'Park';
  questId: typeof PARK_QUEST_ID;
  stepKind: 'kick_ball';
  kickId: string;
};

export type ParkKickProgress = {
  /** Unikalne kickId już policzone. */
  countedKickIds: string[];
  /** Ile unikalnych kopnięć (max steps w katalogu = 3). */
  kicks: number;
};

export function createParkKickProgress(): ParkKickProgress {
  return { countedKickIds: [], kicks: 0 };
}

/**
 * Rejestruje kopnięcie. Ten sam kickId → advanced=false, payload=null.
 */
export function recordParkKick(
  progress: ParkKickProgress,
  kickId: string,
): { progress: ParkKickProgress; advanced: boolean; payload: ParkMissionPayload | null } {
  if (!kickId || progress.countedKickIds.includes(kickId)) {
    return { progress, advanced: false, payload: null };
  }
  const countedKickIds = [...progress.countedKickIds, kickId];
  const kicks = countedKickIds.length;
  const next: ParkKickProgress = { countedKickIds, kicks };
  return {
    progress: next,
    advanced: true,
    payload: {
      sceneKey: 'Park',
      questId: PARK_QUEST_ID,
      stepKind: 'kick_ball',
      kickId,
    },
  };
}

/** Wygodny mapper: jeden kick → payload lub null (bez śledzenia postępu). */
export function parkMissionFromKick(kickId: string): ParkMissionPayload | null {
  if (!kickId) return null;
  return {
    sceneKey: 'Park',
    questId: PARK_QUEST_ID,
    stepKind: 'kick_ball',
    kickId,
  };
}
